import { updatePreferences } from '../../predict/src/core/api/preferences';
import { PreferencesPayload } from '../../predict/src/dashboard/types';

import { createMutation } from '../utils/mutations';

type UpdatePreferencesResult = Awaited<ReturnType<typeof updatePreferences>>;

export const updatePreferencesMutation = (workspaceId: string, organisationId: string, userId: string) =>
  createMutation<PreferencesPayload, UpdatePreferencesResult>({
    mutationFn: data => updatePreferences(workspaceId, organisationId, userId, data)
  });
